"use client";

import { useCallback, useEffect, useMemo, useState } from "react";

export function useMediaListPagination<T>({
  items,
  perPage,
  resetKey,
}: {
  items: T[];
  perPage: number;
  resetKey?: string | number | null;
}) {
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => setCurrentPage(0), [resetKey]);

  const totalPages = Math.max(Math.ceil(items.length / perPage), 1);
  const effectivePage = Math.min(currentPage, totalPages - 1);
  const startIndex = effectivePage * perPage;

  const visibleItems = useMemo(() => items.slice(startIndex, startIndex + perPage), [items, startIndex, perPage]);

  const goNext = useCallback(() => setCurrentPage(p => Math.min(totalPages - 1, p + 1)), [totalPages]);

  const goPrevious = useCallback(() => setCurrentPage(p => Math.max(0, p - 1)), []);

  const resetPage = useCallback(() => setCurrentPage(0), []);

  return {
    currentPage: effectivePage,
    totalPages,
    visibleItems,
    goNext,
    goPrevious,
    resetPage,
  };
}
